import React, { createContext, useState } from "react";

/**
 * @typedef {Object} SupportingInformation
 * @property {string} parent1GivenNames
 * @property {string} parent1FamilyName
 * @property {string} parent2GivenNames
 * @property {string} parent2FamilyName
 * @property {number} genderSourceCode
 * @property {number} nameChangeSourceCode
 * @property {string} inzVisaNumber
 */

/**
 * @typedef {Object} Referee
 * @property {string} familyName
 * @property {string} givenNames
 * @property {string} dateOfBirth
 * @property {number} numberOfYearsKnownFor
 * @property {string} travelDocumentNumber
 * @property {string} emailAddress
 * @property {string} landlinePhone
 * @property {string} mobilePhone
 * @property {string} workPhone
 * @property {string} addressStreet
 * @property {string} addressSuburb
 * @property {string} addressState
 * @property {string} addressPostcode
 * @property {string} addressCity
 * @property {string} addressCountryId
 */

/**
 * @typedef {Object} PhotoShop
 * @property {boolean} flag
 * @property {string} operator
 * @property {string} employeeNumber
 * @property {string} notes
 */

/**
 * @typedef {Object} Liveness
 * @property {string} livenessLink
 * @property {boolean} livenessResult
 * @property {string} livenessId
 * @property {number} livenessStatusCode
 */

/**
 * @typedef {Object} EventTypeSearchItem
 * @property {string} eventTypeId
 * @property {string} documentNumber
 * @property {string} givenNames
 * @property {string} familyName
 * @property {string} placeOfEvent
 * @property {string} dateOfBirth
 * @property {string} countryOfEventId
 * @property {string} countryOfBirthId
 * @property {string} dateOfEvent
 */

/**
 * @typedef {Object} AppState
 * @property {string} applicationId
 * @property {number} applicationFlowCode
 * @property {string} applicationTypeId
 * @property {Applicant} applicant
 * @property {SupportingInformation} supportingInformation
 * @property {Referee} referee
 * @property {PhotoShop} photoShop
 * @property {Liveness} liveness
 * @property {EventTypeSearchItem[]} eventTypeSearch
 */

/**
 * @typedef {Object} AppContextType
 * @property {{ requestPayload: AppState }} appState
 * @property {Function} setAppState
 */

/**
 * @typedef {Object} UserFlows
 * @property {boolean} showLiveness
 * @property {boolean} showPartnerStore
 * @property {boolean} isRenew
 * @property {string} dateOfExpiry
 */

// Create the context
/** @type {React.Context<AppContextType>} */
export const AppContext = createContext();

export const INITIAL_APP_STATE = {
  requestPayload: {
    applicationId: "",
    applicationFlowCode: "",
    applicationTypeId: "",
    applicant: {
      givenNames: "",
      familyName: "",
      dateOfBirth: "",
      placeOfBirth: "",
      genderId: "",
      emailAddress: "",
      landlinePhone: "",
      mobilePhone: "",
      workPhone: "",
      namesKnownAs: [
        {
          nameTypeId: "",
          givenNames: "",
          familyName: "",
        },
      ],
    },
  },
};

export const AppProvider = ({ children }) => {
  const [ userFlows, setUserFlows ] = useState({
    showLiveness: true,
    showPartnerStore: false,
    showRefree: false,
    isRenew: false,
    dateOfExpiry:"",
    isChangeRequested: false,

  });

  const [ userRegister, setUserRegister ] = useState({});
  const [isInitialized, setIsInitialized] = useState(false);

  const [appState, setAppState] = useState(INITIAL_APP_STATE);

  return (
    <AppContext.Provider value={{ appState, setAppState, userFlows, setUserFlows, userRegister, setUserRegister, isInitialized, setIsInitialized }}>
      {children}
    </AppContext.Provider>
  );
};
